// src/Routes/PrivateRoutes.js
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../Utlis/auth";

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
// const PrivateRoute = ({ children }) => {
//   return children; // 🔓 No authentication check
// };

// export default PrivateRoute;